import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaWallet, FaGift, FaTimes, FaLock } from 'react-icons/fa';
import { useStyleCredits } from '../context/StyleCreditsContext';
import { useAuth } from '../context/AuthContext';
import StyleCreditsWallet from './StyleCreditsWallet';
import './StyleCreditsDisplay.css';

const StyleCreditsDisplay = ({ onUseCredits, orderTotal = 0 }) => {
  const { credits } = useStyleCredits();
  const { currentUser } = useAuth();
  const [showWallet, setShowWallet] = useState(false);

  const formatCredits = (amount) => {
    return `₹${amount.toLocaleString()}`;
  };

  const handleWalletToggle = () => {
    if (currentUser) {
      setShowWallet(!showWallet);
    }
  };

  const handleUseCredits = (amount) => {
    onUseCredits(amount);
    setShowWallet(false);
  };


  if (credits.loading) {
    return (
      <div className="style-credits-display style-credits-loading">
        <div className="style-credits-skeleton"></div>
      </div>
    );
  }

  // Show disabled state for non-logged users
  if (!currentUser) {
    return (
      <motion.div 
        className="style-credits-display style-credits-disabled"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        title="Your Style Credits Wallet is waiting. Log in to activate."
      >
        <button 
          className="style-credits-btn style-credits-disabled-btn"
          aria-label="Style Credits Wallet - Log in to activate"
        >
          <div className="style-credits-container">
            <FaWallet className="style-credits-svg" />
          </div>
        </button>
      </motion.div>
    );
  }

  return (
    <>
      <motion.div 
        className="style-credits-display style-credits-compact"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
      >
        <button 
          className="style-credits-btn"
          onClick={handleWalletToggle}
          aria-label={`Style Credits: ${formatCredits(credits.availableCredits)}`}
          title={`Style Credits: ${formatCredits(credits.availableCredits)}`}
        >
          <div className="style-credits-container">
            <FaWallet className="style-credits-svg" />
            {credits.availableCredits > 0 && (
              <div className="style-credits-badge">
                {formatCredits(credits.availableCredits)}
              </div>
            )}
          </div>
        </button>
      </motion.div>

      <AnimatePresence>
        {showWallet && (
          <motion.div 
            className="credits-wallet-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            onClick={() => setShowWallet(false)}
          >
            <motion.div
              className="credits-wallet-container"
              initial={{ opacity: 0, scale: 0.9, y: 20 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 20 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
              onClick={(e) => e.stopPropagation()}
            >
              <StyleCreditsWallet
                onClose={() => setShowWallet(false)}
                onUseCredits={handleUseCredits}
                orderTotal={orderTotal}
              />
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default StyleCreditsDisplay;
